// Copyright (c) StrangeBee 2023

import { QuerySelector } from 'thehive-sdk';

interface ComputeGetSelectorParams {
    dashboardId: string;
}

export const computeGetSelector = ({ dashboardId }: ComputeGetSelectorParams): QuerySelector => ({
    head: [{ name: 'getDashboard', idOrName: dashboardId }],
    name: `get-dashboard-${dashboardId}`,
});

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listDashboard' }],
    name: 'get-all-dashboard',
    sort: ['+group'],
});
